import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 .6c4.643 0 8.4 3.757 8.4 8.4s-3.757 8.4-8.4 8.4A8.395 8.395 0 0 1 .6 9C.6 4.357 4.357.6 9 .6M2.807 13.459a7.64 7.64 0 0 0 5.43 3.177v-1.573a6.13 6.13 0 0 1-4.1-2.368zm11.058-.764a6.13 6.13 0 0 1-4.101 2.367v1.528a7.64 7.64 0 0 0 5.429-3.131zm-.448-6.29a17 17 0 0 1-1.653.245l-1.022 2.906-.996-2.785a26 26 0 0 1-.691.011c-.236 0-.46-.005-.686-.007l-1 2.784-1.024-2.91a16 16 0 0 1-1.647-.245l2.596 6.538.018.046.88-1.608.71-.38-.545.104.6-1.383-.359-.971 1.105.854.215.78-.405-.09.442.314.034.178.54 1.477-.992-.275 1.06.551.193.465h.005l2.622-6.6ZM2.043 5.868a7.53 7.53 0 0 0 0 6.262l1.322-.764a6.13 6.13 0 0 1 0-4.734zm12.593.764a6.13 6.13 0 0 1 0 4.734l1.32.764a7.53 7.53 0 0 0 0-6.262zm-6.4-5.27A7.64 7.64 0 0 0 2.808 4.54l1.33.764a6.13 6.13 0 0 1 4.1-2.367V1.363Zm1.528 1.574a6.13 6.13 0 0 1 4.1 2.367l1.329-.764a7.64 7.64 0 0 0-5.429-3.177z"
    }, null, -1)
  ])))
}
export default { render: render }